import React from "react";
import Card from "components/card";
import Button from "components/button";
import { getVoucherMeta } from "variables/constants";
import { 
    Sparkles, 
    Trophy, ShoppingCart,
} from "lucide-react";

const VoucherDetails = ({ voucher, onClose, onAdd }) => {
    if (!voucher) return null;

    const {
        title,
        description,
        contentDescription,
        value,
        points,
        isTrending = false,
    } = voucher;

    const { icon: Icon, gradientFrom, gradientTo } = getVoucherMeta(description);

    return (
        <Card className="bg-white grid w-full gap-4 rounded-xl border p-6 shadow-lg duration-200 sm:max-w-lg">
            <div className="flex flex-col gap-2 text-center sm:text-left">
                <h2 className="text-lg leading-none font-semibold">
                    {title}
                </h2>
                <p className="text-slate-700 text-sm">
                    {description}
                </p>
            </div>
            <div className="space-y-4">
                <div className={`h-40 rounded-xl bg-gradient-to-br ${gradientFrom} ${gradientTo} flex items-center justify-center`}>
                    {Icon && <Icon className="w-20 h-20 text-white opacity-90" />}
                </div>
            </div>
            <div>
                <h4 className="font-medium mb-2">
                    Description
                </h4>
                <p className="text-[14px] text-slate-700">
                    {contentDescription}
                </p>
            </div>
            <div className="grid grid-cols-2 gap-4">
                <div>
                    <p className="text-[12px] text-slate-700 mb-1">
                        Original Value
                    </p>
                    <p className="text-[18px] font-bold">
                        {value}
                    </p>
                </div>
                <div>
                    <p className="text-[12px] text-slate-700 mb-1">
                        Points Required
                    </p>
                    <p className="text-[18px] font-bold text-emerald-600 flex items-center gap-1">
                        <Sparkles className="w-5 h-5" />
                        {points}
                    </p>
                </div>
            </div>
            {isTrending && (
                <span className="justify-center rounded-xl px-2 py-0.5 text-xs font-medium w-fit whitespace-nowrap shrink-0 transition-[color,box-shadow] bg-gradient-to-r from-orange-500 to-pink-500 text-white border-0 flex items-center gap-1">
                    <Trophy className="w-3 h-3" />
                    Trending Voucher!
                </span>
            )}
            <div className="flex gap-2">
                <Button
                    onClick={onClose}
                    className="flex-1 h-8 border rounded-lg text-sm flex items-center justify-center hover:shadow-none hover:bg-slate-100"
                >
                    Close
                </Button>

                <Button
                    onClick={() => {
                        if (onAdd) onAdd(voucher); 
                        if (onClose) onClose();  
                    }}
                    className="inline-flex items-center justify-center whitespace-nowrap text-sm font-medium outline-none h-8 rounded-md gap-1.5 px-3 flex-1 bg-gradient-to-r from-emerald-600 to-purple-600 hover:from-emerald-700 hover:to-purple-700 hover:shadow-none text-white"
                >
                    <ShoppingCart className="w-4 h-4 mr-1" />
                    Add to Cart
                </Button>
            </div>
        </Card>
    )
};
export default VoucherDetails;